import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { GeneralSelect } from 'v2/form/CustomSelectors/GeneralSelect';
import {
  BulkImportType,
  useBulkImportTypeOptions,
} from '../FileSelection/hooks';
import styles from './BulkFilesSelection.module.scss';
import classnames from 'classnames';
import { BulkFilesUploadForm } from '../../types';
import { BulkFilesUpload } from './components';

interface BulkFilesSelectionProps {
  isBulkUploadFileLoading: boolean;
  onBulkImportTypeChange: (bulkImportType?: BulkImportType) => void;
}

export function BulkFilesSelection({
  isBulkUploadFileLoading,
  onBulkImportTypeChange,
}: BulkFilesSelectionProps) {
  const { control } = useFormContext<BulkFilesUploadForm>();

  const options = useBulkImportTypeOptions();
  const defaultOption = options.find(
    (option) => option.value === BulkImportType.FILE
  );

  return (
    <>
      <div>
        <strong className={classnames(styles.label)}>
          What are you importing?
        </strong>

        <Controller
          name="bulkImportType"
          control={control}
          rules={{
            required: true,
          }}
          defaultValue={defaultOption?.value}
          render={({ field: { value, onChange } }) => {
            const selectedOption = options.find(
              (option) => option.value === value
            );

            return (
              <GeneralSelect
                options={options}
                handleChange={(option) => {
                  onChange(option?.value);
                  onBulkImportTypeChange(option?.value);
                }}
                selectedOption={selectedOption}
                disabled={isBulkUploadFileLoading}
                fullWidth
              />
            );
          }}
        />
      </div>

      <BulkFilesUpload />
    </>
  );
}
